import type { SettingControl } from './setting-anchors.types';

/**
 * The individually addressable options inside cards that hold several unrelated
 * ones — see {@link SettingControl} for why a few cards need this and most do
 * not.
 *
 * Their own module rather than inline in the registry, for the reason the
 * registry's own header gives about splits: this is not a second place to
 * forget an ANCHOR. Every anchor still lives in exactly one map next door; what
 * lives here is the inside of a handful of them, which is a list that grows a
 * row per option while the registry grows a row per card.
 */

/**
 * `/account` — Preferences. Four groups that share a surface and nothing else,
 * which is what makes the card the wrong landing target for someone who typed
 * "language".
 */
export const ACCOUNT_PREFERENCE_CONTROLS: readonly SettingControl[] = [
  {
    id: 'theme',
    labelKey: 'usermenu.theme',
    keywordsKey: 'settingSearch.accountPreferences.theme',
  },
  {
    id: 'mode',
    labelKey: 'usermenu.advancedControls',
    keywordsKey: 'settingSearch.accountPreferences.mode',
  },
  {
    id: 'language',
    labelKey: 'usermenu.language',
    keywordsKey: 'settingSearch.accountPreferences.language',
  },
  {
    id: 'numerals',
    labelKey: 'usermenu.numerals',
    keywordsKey: 'settingSearch.accountPreferences.numerals',
    // The Eastern Arabic-Indic opt-in (ADR-0141) is a no-op outside
    // Arabic, and the card does not render it there — so offering it
    // would be a jump to a control that is not on the page.
    localeOnly: ['ar'],
  },
];
